<form class="w-100 h-100 form" [formGroup]="glossary">
  <h4 class="text-center">Edición de estado de solicitud</h4>
  <div class="display w-100" formArrayName="profiles">
    <ng-container [formGroupName]="i" *ngFor="let profile of glossary.get('profiles')['controls']; index as i">
      <div>
        <span>
          <mat-checkbox formControlName="value"
                        (change)="setChildren(i, $event.checked)" [disabled]="!mantenienceSection">
            {{glossary.get('profiles')['controls'][i].get('name').value}}
            <!-- {{glossary.get('profiles')['controls'][i].get('value').invalid}} x -->
          </mat-checkbox>
        </span>
        <span>
          <ul class="my-3" formArrayName="list">
            <ng-container [formGroupName]="j"
                          *ngFor="let role of glossary.get('profiles')['controls'][i]['controls']['list']['controls']; index as j">
              <li>
                <mat-checkbox formControlName="value" (change)="setParent(i)" [disabled]="!mantenienceSection">
                  {{list[i]['list'][j].name}}
                </mat-checkbox>
              </li>
            </ng-container>
          </ul>
        </span>
      </div>
    </ng-container>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" [disabled]="(!glossary.get('profiles').dirty && glossary.get('profiles').valid) || !mantenienceSection" type="submit" (click)="send()">
      Actualizar datos
    </button>
  </div>
</form>
